import { useState, useMemo } from "react";
import Navbar from "./Navbar";
import { useTheme } from "../context/ThemeContext";
import "../App.css";

import Add from "../assets/icons/light/Add.svg";
import DarkAdd from "../assets/icons/dark/Add.svg";
import Funnel from "../assets/icons/light/FunnelSimple.svg";
import DarkFunnel from "../assets/icons/dark/FunnelSimple.svg";
import ArrowsDownUp from "../assets/icons/light/ArrowsDownUp.svg";
import DarkArrowsDownUp from "../assets/icons/dark/ArrowsDownUp.svg";
import SearchIcon from "../assets/icons/dark/Search.svg";
import LightSearchIcon from "../assets/icons/light/Search.svg";
import User6 from "../assets/images/user6.png";
import User7 from "../assets/images/user7.png";
import User8 from "../assets/images/user8.png";
import User9 from "../assets/images/user9.png";
import User10 from "../assets/images/user10.png";

const initialData = [
  { OrderId: "#CM9801", User: "Natali Craig", Avatar: User6, Project: "Landing Page", Address: "Meadow Lane Oakland", date: "Just now", Status: "In Progress" },
  { OrderId: "#CM9802", User: "Kate Morrison", Avatar: User7, Project: "CRM Admin Page", Address: "Larry San Francisco", date: "A minute ago", Status: "Complete" },
  { OrderId: "#CM9803", User: "Drew Cano", Avatar: User8, Project: "Client Project", Address: "Bagwell Avenue Ocala", date: "1 hour ago", Status: "Pending" },
  { OrderId: "#CM9804", User: "Orlando Diggs", Avatar: User9, Project: "Admin Dashboard", Address: "Washburn Baton Rouge", date: "Yesterday", Status: "Approved" },
  { OrderId: "#CM9805", User: "Andi Lane", Avatar: User10, Project: "App Landing Page", Address: "Nest Lane Olivette", date: "Feb 2, 2023", Status: "Rejected" },
  { OrderId: "#CM9806", User: "Natali Craig", Avatar: User6, Project: "Landing Page", Address: "Meadow Lane Oakland", date: "Just now", Status: "In Progress" },
  { OrderId: "#CM9807", User: "Kate Morrison", Avatar: User7, Project: "CRM Admin Page", Address: "Larry San Francisco", date: "A minute ago", Status: "Complete" },
  { OrderId: "#CM9808", User: "Drew Cano", Avatar: User8, Project: "Client Project", Address: "Bagwell Avenue Ocala", date: "1 hour ago", Status: "Pending" },
  { OrderId: "#CM9809", User: "Orlando Diggs", Avatar: User9, Project: "Admin Dashboard", Address: "Washburn Baton Rouge", date: "Yesterday", Status: "Approved" },
  { OrderId: "#CM9810", User: "Andi Lane", Avatar: User10, Project: "App Landing Page", Address: "Nest Lane Olivette", date: "Feb 2, 2023", Status: "Rejected" },
];

const STATUS_COLORS = {
  "Complete": "#22c55e",
  "Approved": "#facc15",
  "Pending": "#3b82f6",
  "Rejected": "#9ca3af",
  "In Progress": "#a855f7",
};

export default function Orders() {
  const { theme } = useTheme();
  const [data] = useState(initialData);
  const [searchTerm, setSearchTerm] = useState("");
  const [selected, setSelected] = useState([]);
  const [sortAsc, setSortAsc] = useState(true);
  const [filter, setFilter] = useState("All");

  const dark = theme === "#1c1c1c";

  const filteredData = useMemo(() => {
    return data
      .filter((item) => (filter === "All" ? true : item.Status === filter))
      .filter((item) =>
        Object.values(item)
          .join(" ")
          .toLowerCase()
          .includes(searchTerm.toLowerCase())
      )
      .sort((a, b) => (sortAsc ? a.OrderId.localeCompare(b.OrderId) : b.OrderId.localeCompare(a.OrderId)));
  }, [data, filter, searchTerm, sortAsc]);

  const toggleSelectAll = () => {
    if (selected.length === filteredData.length) setSelected([]);
    else setSelected(filteredData.map((item) => item.OrderId));
  };

  const toggleSelectOne = (id) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  return (
    <div
      className={`App min-h-screen transition-all duration-300 ${
        dark ? "bg-[#1c1c1c] text-white" : "bg-white text-black"
      }`}
    >
      <Navbar />

      <div className="mt-[28px] ml-[240px]">
        <p className="font-semibold text-lg mb-4">Order List</p>

        {/* ---- Toolbar ---- */}
        <div
          className={`flex items-center justify-between ${
            dark ? "bg-[#272727]" : "bg-[#f7f9fb]"
          } w-[1152px] h-[44px] rounded-lg py-2 px-2`}
        >
          <div className="flex gap-2">
            {/* Add */}
            <div
              className={`flex items-center gap-2 cursor-pointer rounded-lg p-1 ${
                dark ? "hover:bg-[#3e3e3e]" : "hover:bg-[#ebedef]"
              }`}
            >
              <img
                src={dark ? DarkAdd : Add}
                alt="add"
                className="w-[20px] h-[20px]"
              />
            </div>
            {/* Filter */}
            <div
              className={`flex items-center gap-2 cursor-pointer rounded-lg p-1 ${
                dark ? "hover:bg-[#3e3e3e]" : "hover:bg-[#ebedef]"
              }`}
              onClick={() =>
                setFilter(
                  filter === "All"
                    ? "In Progress"
                    : filter === "In Progress"
                    ? "Complete"
                    : filter === "Complete"
                    ? "Pending"
                    : filter === "Pending"
                    ? "Approved"
                    : filter === "Approved"
                    ? "Rejected"
                    : "All"
                )
              }
            >
              <img
                src={dark ? DarkFunnel : Funnel}
                alt="filter"
                className="w-[20px] h-[20px]"
              />
            </div>
            {/* Sort */}
            <div
              className={`flex items-center gap-2 cursor-pointer rounded-lg p-1 ${
                dark ? "hover:bg-[#3e3e3e]" : "hover:bg-[#ebedef]"
              }`}
              onClick={() => setSortAsc(!sortAsc)}
            >
              <img
                src={dark ? DarkArrowsDownUp : ArrowsDownUp}
                alt="sort"
                className="w-[20px] h-[20px]"
              />
            </div>
          </div>

          {/* Search */}
          <div
            className={`flex items-center ${
              dark
                ? "bg-[#232323] border-2 border-[#393939]"
                : "bg-[#fafbfd] border-2 border-[#e5e6e7]"
            } rounded-lg px-2 py-1 h-[28px] w-[180px]`}
          >
            <img
              src={dark ? SearchIcon : LightSearchIcon}
              alt="Search Icon"
              className="w-[16px] h-[16px]"
            />
            <input
              type="text"
              placeholder="Search"
              className={`bg-transparent focus:outline-none ml-1 mt-0.5 w-full text-sm ${
                dark
                  ? "placeholder:text-[#777777] text-white"
                  : "placeholder:text-[#a4a4a4] text-black"
              }`}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>

        {/* Table */}
        <div
          className='mt-6 w-[1152px] rounded-lg overflow-hidden'
        >
          <table className="min-w-full border-collapse">
            <thead className="border-b-2 border-[#d2d2d2]">
              <tr
                className='text-left text-sm'
              >
                <th className="py-1 px-2">
                  <input
                    type="checkbox"
                    checked={selected.length === filteredData.length}
                    onChange={toggleSelectAll}
                    className="accent-[#4a90e2]"
                  />
                </th>
                <th className="py-1 px-2">Order ID</th>
                <th className="py-1 px-2">User</th>
                <th className="py-1 px-2">Project</th>
                <th className="py-1 px-2">Address</th>
                <th className="py-1 px-2">Date</th>
                <th className="py-1 px-2">Status</th>
              </tr>
            </thead>

            <tbody>
              {filteredData.map((item) => (
                <tr
                  key={item.OrderId + item.Address}
                  className={`text-sm max-h-[40px] border-b relative ${
                    dark
                      ? "border-[#383838] hover:bg-[#333333]"
                      : "border-[#e8eaed] hover:bg-[#f1f3f4]"
                  }`}
                >
                  <td className="py-1 px-2">
                    <input
                      type="checkbox"
                      checked={selected.includes(item.OrderId)}
                      onChange={() => toggleSelectOne(item.OrderId)}
                      className="accent-[#4a90e2]"
                    />
                  </td>
                  <td className="py-1 px-2 font-medium">{item.OrderId}</td>
                  <td className="py-1 px-2 flex items-center gap-3">
                    <img
                      src={item.Avatar}
                      alt={item.User}
                      className="w-[24px] h-[24px] rounded-full object-cover"
                    />
                    <span>{item.User}</span>
                  </td>
                  <td className="py-1 px-2">{item.Project}</td>
                  <td className="py-1 px-2">{item.Address}</td>
                  <td className="py-1 px-2">{item.date}</td>
                  <td className="py-1 px-2 flex gap-1 items-center align-middle">
                       {/* Colored Dot */}
                    <span
                      className="inline-block w-2 h-2 rounded-full"
                      style={{ backgroundColor: STATUS_COLORS[item.Status] }}
                    ></span>
                    <span
                      className={`text-sm font-medium`}
                      style={{ color: STATUS_COLORS[item.Status] }}
                    ></span>
                    <span
                      className={`text-sm  font-medium ${
                        item.Status === "Complete"
                          ? "text-green-500"
                          : item.Status === "Approved"
                          ? "text-yellow-500"
                          : item.Status === "Pending"
                          ? "text-blue-400"
                          : item.Status === "Rejected"
                          ? "text-gray-400"
                          : "text-purple-400"
                      }`}
                    >
                      {item.Status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
